<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="valueYear" :placeholder="$t('placeholder.Year2')" @change="indexSearch(valueYear)">
            <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-cascader
              clearable
              :placeholder="$t('placeholder.Index2')"
              :props="{ checkStrictly: true }"
              :options="optionsIndex"
              v-model="valueIndex">
          </el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="rankSearch(valueIndex)">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
          :data="rateRank.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%">
        <el-table-column
            prop="rank"
            :label="$t('label.Rank')">
        </el-table-column>
        <el-table-column
            :prop=this.CityName
            :label="$t('label.CityName')">
        </el-table-column>
        <el-table-column
            prop="score"
            :label="$t('label.Score')">
        </el-table-column>

        <template slot="empty">
          <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          @current-change="current_change"
          :total="rateRank.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "rateRankSearch",
  data() {
    return {
      CityName:'',
      rateRank:[],
      optionsYear: [],
      optionsIndex: [],
      valueYear: '',
      valueIndex: '',

      pagesize:10,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods: {
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    indexSearch(valueYear){
      this.optionsIndex=[]
      if(valueYear === '2019' || valueYear === '2020'){
        request.get('/dataquery/evaSys?year='+valueYear).then(result => {
          var List = []
          var one={}
          var two={}
          var three={}
          var temp=[]
          var temp1=[]
          var sum={
            label:'',
            value:'',
            children:[]
          }
          if(this.$i18n.locale==='cn'){
            sum.label=result.data[0].name_cn+result.data[0].year
          }
          else{
            sum.label=result.data[0].name_en+result.data[0].year
          }
          sum.value=result.data[0].id
          List = result.data[0].children

          for(let i=0;i<List.length;i++){
            one={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              one.label = List[i].name_cn
            }
            else{
              one.label = List[i].name_en
            }
            one.value = List[i].id
            temp = List[i].children

            for(let j=0;j<temp.length;j++){
              two={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                two.label=temp[j].name_cn
              }
              else{
                two.label=temp[j].name_en
              }
              two.value=temp[j].id
              one.children.push(two)
              temp1 = temp[j].children

              for(let k=0;k<temp1.length;k++){
                three = {
                  label:'',
                  value:''
                }
                if(this.$i18n.locale==='cn'){
                  three.label = temp1[k].name_cn
                }
                else{
                  three.label = temp1[k].name_en
                }
                three.value = temp1[k].id
                two.children.push(three)
              }
            }
            sum.children.push(one)
          }
          this.optionsIndex.push(sum)
          console.log(this.optionsIndex)
        }).catch(err => {
          console.log(err)
        })
      }
      else{
        request.get('/dataquery/evaSys?year='+valueYear).then(result => {
          var List = []
          var one={}
          var two={}
          var temp=[]
          var sum={
            label:'',
            value:'',
            children:[]
          }
          if(this.$i18n.locale==='cn'){
            sum.label=result.data[0].name_cn+result.data[0].year
          }
          else{
            sum.label=result.data[0].name_en+result.data[0].year
          }
          sum.value=result.data[0].id
          List = result.data[0].children

          for(let i=0;i<List.length;i++){
            one={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              one.label = List[i].name_cn
            }
            else{
              one.label = List[i].name_en
            }
            one.value = List[i].id
            temp = List[i].children
            for(let j=0;j<temp.length;j++){
              two={
                label:'',
                value:''
              }
              if(this.$i18n.locale==='cn'){
                two.label=temp[j].name_cn
              }
              else{
                two.label=temp[j].name_en
              }
              two.value=temp[j].id
              one.children.push(two)
            }
            sum.children.push(one)
          }
          this.optionsIndex.push(sum)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    rankSearch(valueIndex){
      if(valueIndex.length!=0){
        request.get('/dataquery/rank?eva_index_id='+valueIndex[valueIndex.length-1]).then(result => {
          var tempList=[]
          tempList = result.data
          var prescore = 0;//预定义分数
          var ranking = 0;//排名
          var same = 0; //是否相同

          for(let i=0;i<tempList.length;i++){
            if(tempList[i].score===prescore){
              tempList[i].rank=ranking
              same++;
            }
            else{
              ranking = ranking + same;
              ranking++;
              prescore = tempList[i].score;
              same=0;
              tempList[i].rank = ranking;
            }
          }
          this.rateRank=tempList
        }).catch(err => {
          console.log(err)
        })
      }
      if(valueIndex.length===0){
        if(this.$i18n.locale==='cn'){
          alert("请选择查询指标！")
        }
        else{
          alert("Please select query index!")
        }
      }
    }
  },
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.CityName="city.name_cn"
    }
    else{
      this.CityName="city.name_en"
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>